import { Reducer } from "redux"
import { LOCATION_CHANGE, RouterAction } from "connected-react-router"

import { AuthUserType, SuperTasksAppType } from "../../Actions/Types"
import { SuperTaskModel } from "../../Models/API/SuperTaskModel"
import { AuthAction } from "../Auth"

export interface SuperTasksAppState {
    list?: SuperTaskModel[]
    isStale: boolean
    isLoading: boolean
    error?: string
}
export interface SuperTasksState {
    [appID: string]: SuperTasksAppState | undefined
}

interface SetSuperTasksListAction {
    type: SuperTasksAppType.setList
    payload: {
        list: SuperTaskModel[]
        appID: string
    }
}

interface RequestSuperTasksListAction {
    type: SuperTasksAppType.listRequest
    payload: {
        appID: string
    }
}

interface SetSuperTasksListErrorAction {
    type: SuperTasksAppType.setListError
    payload: {
        error: string
        appID: string
    }
}

export type SuperTasksAction =
    | SetSuperTasksListAction
    | SetSuperTasksListErrorAction
    | RequestSuperTasksListAction

const initialState: SuperTasksState = {}

export const SuperTasksReducer: Reducer<
    SuperTasksState,
    SuperTasksAction | AuthAction | RouterAction
> = (state = initialState, action): SuperTasksState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return Object.entries(state).reduce((obj, [key, value]) => {
                obj[key] = value
                    ? {
                          ...value,
                          isStale: true
                      }
                    : undefined
                return obj
            }, {} as Record<string, SuperTasksAppState | undefined>)
        case SuperTasksAppType.listRequest:
            return {
                ...state,
                [action.payload.appID]: {
                    ...state[action.payload.appID],
                    isStale: true,
                    isLoading: true
                }
            }
        case SuperTasksAppType.setList:
            return {
                ...state,
                [action.payload.appID]: {
                    ...state[action.payload.appID],
                    isLoading: false,
                    isStale: false,
                    list: action.payload.list
                }
            }
        case SuperTasksAppType.setListError:
            return {
                ...state,
                [action.payload.appID]: {
                    ...state[action.payload.appID],
                    isLoading: false,
                    isStale: false,
                    error: action.payload.error
                }
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
